// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ServiceHistoryItems_wrapper__oJEBC"};